<template>
  <div class="sn-f-b-s report-detail">
    <sn-navigator id="BGCX" :initial="initial"></sn-navigator>
    <div class="sn-f-1 sn-f-s-1 sn-f-col-b-s report-detail-region">
      <sn-breadcrumb :breadcrumb="[{
        title: $sn.utils.getFunctionTitle('0', initial),
        replace: true,
        router: `/query/report?type=${reportType}`,
      }, {
        title: `${$sn.utils.getFunctionTitle('0', initial)}详情`
      }]"></sn-breadcrumb>
      <div class="sn-f-1 sn-f-s-1 detail-blank">
        <!-- 核酸报告 -->
        <template v-if="['3'].includes(reportDetailInfo.selectedTab)">
          <div class="sn-f-c-c detail-title">{{reportDetailInfo.category}}</div>
          <div class="detail-head">
            <div class="sn-f-b-c">
              <div class="sn-f-s-c">
                <div>姓名：{{reportDetailInfo.patientName}}</div>
                <div class="sn-ph-10"></div>
                <div >身份证：{{reportDetailInfo.idCardNo}}</div>
              </div>
              <!-- 是否显示核酸报告下载(报告详情) -->
              <div class="sn-fc-main sn-f-s-c sn-pointer" v-if="$sn.getConfig('isShowNucleicReportDownLoad')" @click="getReportDownload">
                <div class="iconfont icon-xiazai"></div>
                <div class="sn-ph-10">报告下载</div>
              </div>
            </div>
            <!-- 核酸报告查询结果是否显示项目和单号 -->
            <template  v-if="$sn.getConfig('isNucleicAcidReportQueryProjectSingleNumber')">
              <div class="margin-top-10">项目名称：{{reportDetailInfo.itemName}}</div>
              <div class="margin-top-10">检验单号：{{reportDetailInfo.itemReqNo}}</div>
            </template>
            <!-- 核酸报告查询结果是否显示检验结果和报告时间 -->
            <template v-else-if="$sn.getConfig('isNucleicAcidReportQueryResultTime')">
              <div class="margin-top-10">检测结果：{{reportDetailInfo.reportAnswer}}</div>
              <div class="margin-top-10">报告时间：{{reportDetailInfo.reportDate}}</div>
            </template>
          </div>
        </template>

        <!-- 病理报告 -->
        <template v-else-if="['4'].includes(reportDetailInfo.selectedTab)">
          <div class="sn-f-c-c detail-title">{{reportDetailInfo.category}}</div>
          <div class="detail-head">
            <div class="sn-f-b-c">
              <div class="sn-f-s-c">
                <div>姓名：{{reportDetailInfo.patient.patientName}}</div>
                <div class="sn-ph-10"></div>
                <div >性别：{{reportDetailInfo.sex === '2' ? '女' : '男'}}</div>
              </div>
            </div>
            <div class="margin-top-10">检查单号：{{reportDetailInfo.reqNo}}</div>
            <div class="margin-top-10">检查项目：{{reportDetailInfo.itemSubClass}}</div>
          </div>
        </template>

        <!-- 内镜报告(胃镜报告) 其他报告(超声报告) -->
        <template v-else-if="['5', '20'].includes(reportDetailInfo.selectedTab)">
          <div class="sn-f-c-c detail-title">{{reportDetailInfo.category}}</div>
          <div class="detail-head">
            <div class="sn-f-b-c">
              <div class="sn-f-s-c">
                <div>姓名：{{reportDetailInfo.patientName}}</div>
                <div class="sn-ph-10"></div>
                <div >身份证：{{reportDetailInfo.idCardNo}}</div>
              </div>
              <div class="sn-fc-main sn-f-s-c sn-pointer" @click="getReportDownload">
                <div class="iconfont icon-xiazai"></div>
                <div class="sn-ph-10">报告下载</div>
              </div>
            </div>
            <div class="margin-top-10">项目名称：{{reportDetailInfo.itemName}}</div>
            <div class="margin-top-10">检验单号：{{reportDetailInfo.itemReqNo}}</div>
          </div>
        </template>
        <!-- 全部报告 检查报告 检验报告 病理报告 -->
        <template v-else>
          <div class="sn-f-c-c detail-title">{{reportDetailInfo.category}}</div>
          <div class="detail-head">
            <div class="sn-f-b-c">
              <div class="sn-f-s-c">
                <div>姓名：{{reportDetailInfo.patient.patientName}}</div>
                <div class="sn-ph-10">检查时间：{{$sn.format.date(new Date(reportDetailInfo.checkTime), 'yyyy年MM月dd日')}}</div>
                <div v-if="reportDetailInfo.deptName">检查科室：{{reportDetailInfo.deptName}}</div>
              </div>
              <div class="sn-fc-main sn-f-s-c sn-pointer" v-if="showDownload" @click="getReportDownload">
                <div class="iconfont icon-xiazai"></div>
                <div class="sn-ph-10">报告下载</div>
              </div>
            </div>
            <div class="margin-top-10" v-if="$sn.getConfig('isShowReqNoFields') && reportDetailInfo.reqNo">检查单号：{{reportDetailInfo.reqNo}}</div>
            <div class="margin-top-10">检查项目：{{reportDetailInfo.itemClass}}</div>
          </div>
        </template>
        <template v-if="!$sn.validate.empty(handleDetail)">
          <template v-if="reportDetailInfo.category === '检查报告'">
            <div class="sn-table">
              <table>
                <thead>
                  <tr>
                    <th v-if="handleDetail[0].description">检查表现</th>
                    <th v-if="handleDetail[0].impression">检查诊断</th>
                  </tr>
                </thead>
                <tbody>
                  <tr :key="index" v-for="(detail, index) in handleDetail">
                    <td v-if="detail.description">{{detail.description}}</td>
                    <td v-if="detail.impression">{{detail.impression}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </template>
          <template v-else-if="reportDetailInfo.category === '检验报告'">
            <div class="sn-table" @scroll.passive="handleScroll">
              <table>
                <thead>
                  <tr>
                    <th>项目名称</th>
                    <th>结果&结论</th>
                    <th>单位</th>
                    <th>参考范围</th>
                  </tr>
                </thead>
                <tbody>
                  <tr :key="index" v-for="(detail, index) in handleDetail">
                    <td>{{detail.itemName}}</td>
                    <td>{{detail.result}}
                      <span v-if="detail.indicator === '1'" class="sn-fc-red1 iconfont icon-xiangshang"></span>
                      <span v-if="detail.indicator === '-1'" class="sn-fc-red1 iconfont icon-paixu"></span>
                    </td>
                    <td>{{detail.units}}</td>
                    <td>{{detail.resultRange}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </template>
          <template v-else-if="reportDetailInfo.category === '病理报告'">
            <div class="sn-table">
              <table>
                <thead>
                  <tr>
                    <th>病人类别号码</th>
                    <th>检查科室</th>
                    <th>诊断医生</th>
                    <th>诊断信息</th>
                    <th>报告时间</th>
                  </tr>
                </thead>
                <tbody>
                  <tr :key="index" v-for="(detail, index) in handleDetail">
                    <td>{{detail.patientTypeCode}}</td>
                    <td>{{detail.deptName}}</td>
                    <td>{{detail.auditDocName}}</td>
                    <td>{{detail.diagnostic}}</td>
                    <td>{{detail.reportTime}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </template>
          <div class="prompt-message" v-if="['5', '20'].includes(reportDetailInfo.selectedTab)">温馨提示：如下载PDF报告失败，由于PDF报告发布有延迟，您的报告单可能暂未生成，请稍后再试，感谢您的配合！</div>
          <!-- 核酸报告温馨提示 -->
          <div class="prompt-message" v-else-if="['3'].includes(reportDetailInfo.selectedTab)">{{ $sn.getConfig('nucleicAcidReportQueryDetailsReminder')}}</div>
          <div class="prompt-message" v-else>本结果仅对此标本负责,仅供临床医生参考。</div>
        </template>
        <template v-else>
          <sn-no-data></sn-no-data>
        </template>
        <!-- 云胶片下载（仅检查报告类型，根据modalityCloudImage配置判断） -->
        <div class="sn-f-c-c button-blank" v-if="isShowCloudImageDownLoad && reportDetailInfo.reportType === 'check'">
          <div class="cloud-film-btn sn-f-c-c sn-pointer" @click="getCloudImageDownLoad">云胶片下载</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
import Swagger from '@/common/utils/swagger';
import * as Constants from '@/common/utils/constants';
import * as Messages from '@/common/utils/messages';
import self from '@/common/utils/global-config';
import * as Tools from '@/common/utils/tools';
import * as ServiceConfig from '@/common/utils/service-config';

export default {
  data() {
    return {
      reportType: '',
      perpetual: Constants,
      detailInfo: [],
      reportDetailInfo: {},
      pageCount: 1,
      isResult: true,
      isShowReportDownload: self.$sn.getConfig('isShowReportDownload'),
      isShowCheckReportDownload: self.$sn.getConfig('isShowCheckReportDownload'),
      // 云胶片下载按钮是否显示
      isShowCloudImageDownLoad: false
    };
  },
  computed: {
    // 处理报告信息
    handleDetail() {
      let handle = [];
      if (this.detailInfo.length > 0) {
        handle = this.detailInfo;
      }
      return handle;
    },

    // 当前功能 ID
    initial() {
      return [this.perpetual.FUNCTION_ID_MZBG, this.perpetual.FUNCTION_ID_ZYBG][this.reportType - 1];
    },

    // 是否显示报告下载按钮
    showDownload() {
      if (this.reportDetailInfo.reportType === 'check' && this.reportDetailInfo.modalityType === 'showDownLoadButton' && this.isShowCheckReportDownload) {
        return true;
      }
      if (this.reportDetailInfo.reportType === 'examine' && this.isShowReportDownload) {
        return true;
      }
      // 山东省肿瘤医院特殊逻辑
      if (this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_SDSZL) {
        if (this.isShowReportDownload) {
          if (this.reportDetailInfo.reportType === 'check') {
            return this.isShowCheckReportDownload;
          }
          return true;
        }
      }
      return false;
    }
  },
  watch: {},
  async created() {
    this.reportType = this.$route.query.type || '1';
    document.title = `${this.$sn.utils.getFunctionTitle('0', this.initial)}详情`;
    this.$route.meta.title = `${this.$sn.utils.getFunctionTitle('0', this.initial)}详情`;
    this.reportDetailInfo = this.$sn.utils.getHospitalSessionStorage('report_Info');
    this.handleDetailInfo(this.reportDetailInfo);

    await Tools.getHospitalConfigInformation([
      this.perpetual.CONFIG_TYPE_NUCLEIC_ACID // 核酸报告模块
    ]);
  },
  methods: {
    handleScroll() {
      if (this.isResult) {
        this.pageCount++;
        this.getExamineDetail();
      }
    },
    // 查询报告详情
    handleDetailInfo() {
      if (this.$sn.validate.empty(this.reportDetailInfo)) return false;
      // 初始化云胶片下载按钮状态
      this.initCloudImageDownLoad();
      // 病理报告
      if (['4'].includes(this.reportDetailInfo.selectedTab)) {
        this.reportDetailInfo.category = '病理报告';
        this.detailInfo = [this.reportDetailInfo];
        return false;
      }
      // 核酸报告 病理报告 内镜报告(胃镜报告) 其他报告(超声报告)
      else if (['3', '5', '20'].includes(this.reportDetailInfo.selectedTab)) {
        this.detailInfo = [this.reportDetailInfo];
        return false;
      }
      if (this.$sn.validate.empty(this.reportDetailInfo.reqNo)) return false;
      if (this.reportDetailInfo.reportType === 'check') this.getCheckDetail();
      else if (this.reportDetailInfo.reportType === 'examine') this.getExamineDetail();
    },
    // 检查详情
    getCheckDetail() {
      const params = {
        url: this.$sn.format.caption(Swagger.getCheckInfo, [this.$sn.utils.getHospitalId()]),
        query: {
          hosId: this.$sn.utils.getHospitalId(),
          platformId: this.$sn.utils.getPlatformType(),
          platformUserId: this.$sn.utils.getOpenId(),
          reqNo: this.reportDetailInfo.reqNo,
          patName: encodeURIComponent(this.reportDetailInfo.patient.patientName),
          idCardNo: this.reportDetailInfo.patient.patientIdCardNo,
          cardNo: this.reportDetailInfo.cardNo,
          itemClass: this.reportDetailInfo.itemClass,
          admID: this.reportDetailInfo.admID
        },
        header: true
      };
      this.$sn.assembly.loading(true);
      this.$sn.utils.ordinaryRequest(params).then(result => {
        this.$sn.assembly.loading(false);
        if (result && result.code === 0 && result.data) {
          if (result.data.length > 0) this.detailInfo = result.data;
          else this.detailInfo = [];
        }
        else this.$sn.assembly.toast({ caption: result?.msg || Messages.C001 });
      });
    },
    // 检验详情
    getExamineDetail() {
      const params = {
        url: this.$sn.format.caption(Swagger.getExamineInfo, [this.$sn.utils.getHospitalId()]),
        query: {
          hosId: this.$sn.utils.getHospitalId(),
          platformId: this.$sn.utils.getPlatformType(),
          platformUserId: this.$sn.utils.getOpenId(),
          reqNo: encodeURIComponent(this.reportDetailInfo.reqNo),
          page: this.pageCount,
          sex: '',
          age: '',
          size: this.perpetual.PAGINATION_SIZE,
          admID: this.reportDetailInfo.admID
        },
        header: true
      };
      this.$sn.assembly.loading(true);
      this.$sn.utils.ordinaryRequest(params).then(result => {
        this.$sn.assembly.loading(false);
        if (result && result.code === 0 && result.data) {
          if (result.data.length > 0) {
            const x = JSON.parse(JSON.stringify(result.data).replace(new RegExp('&nbsp;', 'g'), ''));
            this.isResult = result.data.length === this.perpetual.PAGINATION_SIZE;
            if (this.pageCount === 1) this.detailInfo = x;
            else this.detailInfo = this.detailInfo.concat(x);
          }
          else this.isResult = false;
        }
        else {
          this.isResult = false;
          this.$sn.assembly.toast({ caption: result?.msg || Messages.C001 });
        }
      });
    },
    // 初始化云胶片下载按钮显示状态（仅检查报告类型，检查报告类型支持云影像
    initCloudImageDownLoad() {
      if (this.reportDetailInfo.reportType !== 'check') return;
      const configValue = this.$sn.getConfig('modalityCloudImage');
      if (this.$sn.validate.empty(configValue)) return;
      const arr = configValue.split(',');
      if (arr.length > 0) {
        // -1 代表全部支持云影像下载
        if (arr[0] === '-1') {
          this.isShowCloudImageDownLoad = true;
        }
        // 包含当前检查报告的modalityType，也展示云影像下载按钮
        else if (arr.includes(this.reportDetailInfo.modalityType)) {
          this.isShowCloudImageDownLoad = true;
        }
      }
    },
    // 云胶片下载
    getCloudImageDownLoad() {
      // 文登整骨医院直接使用accessionno链接
      if (this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_WDZG) {
        if (this.detailInfo.length > 0 && this.detailInfo[0].accessionno) {
          window.open(this.detailInfo[0].accessionno);
        }
        return;
      }
      // 构建默认XML参数
      let xml = `<Request>
        <IdCardNo>${this.reportDetailInfo.patient.patientIdCardNo}</IdCardNo>
        <PatName>${this.reportDetailInfo.patient.patientName}</PatName>
        <ReqNo>${this.reportDetailInfo.reqNo}</ReqNo>
        <CheckDate>${this.reportDetailInfo.checkTime}</CheckDate>
        <HisPatId></HisPatId>
        <CardType></CardType>
      </Request>`;
      // 肿瘤医院使用特殊参数格式
      if (this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_SDSZL) {
        xml = this.$sn.format.xml({
          PlatformId: this.$sn.utils.getPlatformType(),
          PlatformUserId: this.$sn.utils.getOpenId(),
          Type: '3',
          Data: JSON.stringify({
            reqNo: this.reportDetailInfo.reqNo,
            patName: this.reportDetailInfo.patient.patientName
          })
        });
      }
      const params = {
        url: this.$sn.format.caption(Swagger.ordinaryTransmitLogin, [this.$sn.utils.getHospitalId(), this.$sn.getConfig('functionReportCloudFilmCode')]),
        method: 'POST',
        header: true,
        data: this.$sn.utils.variableEncryption(xml)
      };
      this.$sn.assembly.loading(true);
      this.$sn.utils.ordinaryRequest(params, ServiceConfig.ordinaryTransmitLoginComplete).then(result => {
        this.$sn.assembly.loading(false);
        const res = result.data;
        if (res && res.ResultCode === '0' && res.Data) {
          // 非济南市市中区人民医院使用Data.url，其他使用Data
          const url = (res.Data.url && this.$sn.utils.getHospitalId() !== this.perpetual.HOSPITAL_ID_JNSSZQRM) ? res.Data.url : res.Data;
          const openUrl = url.indexOf('https:') > -1 ? url : url.indexOf('http:') > -1 ? url.replace('http:', 'https:') : `https:${url}`;
          window.open(openUrl);
        }
        else {
          this.$sn.assembly.toast({
            caption: res && res.ResultMsg ? res.ResultMsg : Messages.C001
          });
        }
      });
    },
    // 报告下载
    getReportDownload() {
      if (this.$sn.utils.getHospitalId() === Constants.HOSPITAL_ID_SDQL && ['3', '20', '5'].includes(this.reportDetailInfo.selectedTab)) {
        window.open(this.reportDetailInfo.pdfUrl);
        return false;
      }
      let type = 'JY';
      if (this.reportDetailInfo.reportType === 'check' && this.reportDetailInfo.modalityType === 'showDownLoadButton' && this.isShowCheckReportDownload) {
        type = 'JC';
      }
      // 山东省肿瘤医院检查报告使用CS类型
      if (this.reportDetailInfo.reportType === 'check' && this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_SDSZL && this.isShowCheckReportDownload) {
        type = 'CS';
      }
      const params = {
        url: this.$sn.format.caption(Swagger.downloadPDF, [this.$sn.utils.getHospitalId()]),
        query: {
          platformId: this.$sn.utils.getPlatformType(),
          platformUserId: this.$sn.utils.getOpenId(),
          reqNo: encodeURIComponent(this.reportDetailInfo.reqNo),
          type: type
        },
        header: true
      };
      this.$sn.assembly.loading(true);
      this.$sn.utils.ordinaryRequest(params).then(result => {
        this.$sn.assembly.loading(false);
        if (result && (result.code === '0' || result.code === 0)) {
          if (result.data) {
            if (this.$sn.validate.empty(result.data.url)) {
              this.$sn.assembly.toast({ caption: '暂未生成报告' });
            }
            else {
              const url = result.data.url.indexOf('https:') > -1 ? result.data.url : result.data.url.indexOf('http:') > -1 ? result.data.url.replace('http:', 'https:') : `https:${result.data.url}`;
              window.open(url);
            }
          }
          else this.$sn.assembly.toast({ caption: result?.msg || Messages.C001 });
        }
        else {
          this.$sn.assembly.toast({ caption: Messages.C001 });
        }
      });
    }
  },
  beforeDestroy() {}
};
</script>
<style lang="scss" scoped>
.report-detail {
  overflow: hidden;
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1;
  background: $white;
  left: 0;
  top: 0;

  &-region {
    overflow: hidden;
    height: 100%;

    .detail-blank {
      overflow: hidden;
      width: 100%;
      height: 100%;
      padding: 20px 10% 0;
      display: flex;
      flex-direction: column;

      .detail-title {
        font-size: 20px;
        margin-bottom: 20px;
        font-weight: bold;
      }

      .detail-head {
        font-size: 16px;
        margin-bottom: 10px;
        border-bottom: 1px solid $border1;
        padding-bottom: 10px;

        .margin-top-10 {
          margin-top: 10px;
        }
      }

      .sn-table {
        table {
          table-layout: fixed;
        }

        thead {
          background-color: $background1;

          th {
            color: $text1;
            border-right: 1px solid $white;
            border-radius: 0;

            &:last-child {
              border-right: 1px solid $border1;
            }
          }
        }

        th,
        td {
          @include fs(14);

          height: auto;
          min-height: 30px;
          color: $text1;
        }

        td {
          padding: 10px;
        }
      }

      .prompt-message {
        font-size: 16px;
        color: $red1;
        padding: 10px 0;
      }

      // 云胶片下载按钮
      .button-blank {
        margin: 20px 0;

        .cloud-film-btn {
          @include fs(16);

          width: 200px;
          height: 46px;
          color: $white;
          background-color: $main1;
          border-radius: 23px;
          cursor: pointer;
          transition: all 0.2s;

          &:hover {
            opacity: 0.85;
          }
        }
      }
    }
  }
}
</style>
